function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable linebreak-style */
// ----------------------------------------------------------------------------
// Component: iam-cart-icon
// ----------------------------------------------------------------------------
// The iamCartIcon class provides a custom element for displaying the cart icon with the item count.
// It uses the iamotaEventHandler to listen to cart updates and updates the item count accordingly.
// It leverages the scripts/helpers/iamota-shopify-ajax library for fetching cart data.

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { cart } from 'scripts/helpers/iamota-shopify-ajax';

// -------------------------------------
// Web Component
// -------------------------------------

class iamCartIcon extends HTMLElement {
  connectedCallback() {
    // Variables
    this.cartItemCount = this.querySelector('[data-item-count]');

    // Subscribe to the 'cart:modified' event to update the cart icon when the cart is modified
    iamotaEventHandler.subscribe('cart:modifying', this.onCartModifying.bind(this), {
      source: "cart-icon.js"
    });
    iamotaEventHandler.subscribe('cart:modified', this.onCartModified.bind(this), {
      source: "cart-icon.js"
    });
    iamotaEventHandler.subscribe('cart:fetch:error', this.onError.bind(this), {
      source: "cart-icon.js"
    });

    // Fetch and update the cart icon on initialization
    this.forceUpdate();
  }

  /**
   * Updates the cart icon item count
   */
  updateIcon(item_count) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var oldValue = _this.cartItemCount.textContent;
      var newValue = item_count.toString();
      newValue = yield iamotaEventHandler.applyFilters('cartIcon:update', newValue, {
        oldValue
      });
      _this.cartItemCount.value = newValue;
      _this.cartItemCount.textContent = newValue;
      iamotaEventHandler.trigger('cartIcon:updated', {
        oldValue,
        newValue
      }, {
        context: _this
      });
    })();
  }

  /**
   * Fetches the cart data to trigger the cart icon item count to refresh
   */
  forceUpdate() {
    cart.fetch();
  }

  /**
   * Toggles the loading state by adding or removing the --loading modifier class.
   *
   * @param {boolean} isLoading - Whether to show the loading state.
   */
  setLoading(isLoading) {
    this.classList.toggle('--loading', isLoading);
  }

  /**
   * Cart is being modified
   */
  onCartModifying() {
    this.setLoading(true);
  }

  /**
   * Cart has been modified
   */
  onCartModified(cart) {
    this.updateIcon(cart.item_count).finally(() => {
      this.setLoading(false);
    });
  }

  /**
   * Cart data has an error
   */
  onError() {
    this.updateIcon('').finally(() => {
      this.setLoading(false);
    });
  }
}

// Define the custom element
customElements.define('iam-cart-icon', iamCartIcon);